import styles from './styles.module.scss';

const ScoringBar = ({ cropId, value, crops, children }) => {
  return (
    <div
      className={`${styles.scoringBar} ${(!value && value !== 0) && styles.scoringBarInactive}`}
      style={{
        color:
          crops && cropId && value
            ? crops.filter((c) => c.id === cropId)[0].color
            : 'rgba(0,0,0,.35)',
        width: value ? `${value}%` : '280px',
      }}
    >
      {children}
    </div>
  );
};

export default ScoringBar;
